import { render } from "./LearningPlanDetails.vue?vue&type=template&id=5cb2ce26"
import script from "./LearningPlanDetails.vue?vue&type=script&lang=js"
export * from "./LearningPlanDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__